// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"217":"63ac5b1ba3e00a2a","780":"b0698d5aa024982c","983":"53c7a842452ac8a1"}[chunkId] + ".js";
};